import { useQuery } from 'react-query';
import { Invoice } from '@integration-services/xepelin-server-global/invoices/services/invoicesServicesTypes';
import { getInvoicesByClients } from '@finance/services/getInvoicesByClients';

export const useInvoiceByClients = ({ invoices }: { invoices: Invoice[] }) =>
  useQuery([useInvoiceByClients.name, invoices], () => {
    return getInvoicesByClients({ invoices });
  });
